import { type z } from 'zod'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'

import { balanceSchema } from '../..'

const TWO_MINUTES = 60 * 1000 * 2

const MarketBalanceResponseSchema = balanceSchema

export type MarketBalanceResponse = z.infer<typeof MarketBalanceResponseSchema>

async function fetchMarketBalance({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/storefront/balance`,
    method: 'GET'
  })

  return MarketBalanceResponseSchema.parse(data)
}

export function getUseFetchMarketBalanceKey({ accountId }: { accountId: string }) {
  return ['useFetchMarketBalance', accountId] as const
}

export function useFetchMarketBalance({ accountId, options }: { accountId: string; options?: { suspense?: boolean } }) {
  return useQueryRequest<Awaited<ReturnType<typeof fetchMarketBalance>>, unknown, true>(
    [...getUseFetchMarketBalanceKey({ accountId })],
    () => fetchMarketBalance({ accountId }),
    {
      suspense: true,
      refetchInterval: TWO_MINUTES,
      refetchIntervalInBackground: true,
      ...options
    }
  )
}
